<template>
  <template v-if="answerRenderKind && answerRender">
    <RenderMathQuestion
      :question-kind="answerRenderKind"
      :question="answerRender"
    />
  </template>
  <template v-else-if="question?.answerKind == 'buttons'">
    <div v-if="answerOption">
      <RenderMathQuestion
        :question-kind="optionFormat"
        :question="answerOptionLabel"
      />
    </div>
  </template>
  <template v-else-if="question?.answerKind == 'singleop'">
    <div v-if="answerOption">
      <RenderMathQuestion
        :question-kind="optionFormat"
        :question="answerOptionLabel"
      />
    </div>
  </template>
  <template v-else-if="jsonData !== null">
    <template v-if="isPlain">
      {{ answer }}
    </template>
    <template v-else-if="question?.answerKind == 'multiop'">
      <div>
        {{ jsonData.join(", ")}}
      </div>
    </template>
    <template v-else>
      <div v-for="(a, i) in jsonData" :key="i">
        <div :class="a.color ? 'g-color-' + a.color : ''">
          <template v-if="a.label">{{ a.label }}: </template>
          <FormattedNumber 
            v-if="!isNaN(Number(a.value))"
            :value="Number(a.value)" 
            :format="a.fullFormat" 
          />
          <template v-else>
            {{ a.value }}
          </template>
        </div>
      </div>
    </template>
  </template>
</template>

<script lang="ts">
import {
  SfMathLevelAnswerOption,
  SfMathLevelFormat,
  SfMathTestQuestion,
} from "@/types/mathsTypes";
import { defineComponent, PropType } from "vue";
import RenderMathQuestion from "./RenderMathQuestion.vue";
import FormattedNumber from "./FormattedNumber.vue";
import { Dict } from "@/types/generalTypes";

export default defineComponent({
  components: { RenderMathQuestion, FormattedNumber },
  props: {
    question: { type: Object as PropType<SfMathTestQuestion> },
    answer: { type: [String, Number, Object], required: true },
    answerRenderKind: { type: String as PropType<SfMathLevelFormat> },
    answerRender: { type: String },
    formats: { type: Object as PropType<Dict<any>> },
  },
  data() {
    return {
      jsonData: null as any,
      error: null as null | string,
      isPlain: false,
    };
  },
  computed: {
    optionFormat(): SfMathLevelFormat {
      return this.question?.answerUi?.optionsFormat || "text";
    },
    answerOption(): SfMathLevelAnswerOption | null {
      if (!this.question?.answerUi?.options) {
        return null;
      }
      for (const b of this.question.answerUi.options) {
        if (b.value == this.answer) {
          return b;
        }
      }
      return null;
    },
    answerOptionLabel() {
      if (this.answerOption) {
        if(this.answerOption.label.trim() !== '') {
          return this.answerOption.label;
        }
        return this.answerOption.value;
      }
      return '';
    }
  },
  mounted() {
    this.refreshJsonData();
  },
  methods: {
    async refreshJsonData() {
      if (typeof this.answer != "string" && typeof this.answer != "number") {
        this.isPlain = false;
        this.jsonData = this.answer;
      } else {
        this.isPlain = false;
        this.jsonData = null;
        let json;
        try {
          json = await JSON.parse(this.answer + "");
        } catch (e) {
          this.isPlain = true;
          this.jsonData = this.answer;
          return;
        }
        if (typeof json == "number" || typeof json == "string") {
          this.isPlain = true;
        }
        this.jsonData = json;
      }
      if (!this.isPlain && !Array.isArray(this.jsonData)) {
        const newJson = [];
        for (let i in this.jsonData) {
          const q = this.question?.answerFields?.filter(
            (f) => f.name == i);
          const it = {
            name: i,
            value: this.jsonData[i],
            fullFormat: this.formats?.[i] || null,
            color: q?.[0]?.color || null,
            label: q?.[0]?.label || null,
          };
          newJson.push(it);
        }
        this.jsonData = newJson;
      }
    },
  },
});
</script>
